// extracted by mini-css-extract-plugin
module.exports = {"step-indicator":"step-indicator__1y7D-","step-item":"step-item__HAVW7","current":"current__26Umj","subtitle":"subtitle__i6YQ2","title":"title__1hWLI","arrow":"arrow__283vf"};